export const getCurrentOrderItemCount = ascendingOrderItems =>
  ascendingOrderItems.reduce((itemCount, { quantity }) => {
    const parsed = parseInt(quantity);
    return Number.isInteger(parsed) ? itemCount + parsed : itemCount;
  }, 0);
